'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconChartDiagramParentFocusTwoChild, iconChartDiagramParentFocusTwoChildTag } from '@ni/nimble-components/dist/esm/icons/chart-diagram-parent-focus-two-child';
import { wrap } from '../../utilities/react-wrapper';

export type { IconChartDiagramParentFocusTwoChild };
export { iconChartDiagramParentFocusTwoChildTag };
export const NimbleIconChartDiagramParentFocusTwoChild = wrap(IconChartDiagramParentFocusTwoChild);